import type { Address } from "@/types";

export const COMMON_TOKEN_IDS = {
    USDC: "USDC",
    IUSD: "IUSD",
    SIUSD: "SIUSD",
    // DAI: "DAI",
    USDT: "USDT",
    SUSDE: "SUSDE",
    USDE: "USDE",
    USDO: "USDO",
    LIUSD: "LIUSD",
} as const;

export const PENDLE_PT_LOCK_TOKEN_IDS = {
    PT_USDE_25SEP2025: "PT_USDE_25SEP2025",
    PT_SUSDE_25SEP2025: "PT_SUSDE_25SEP2025",
    PT_WSTUSR_25SEP2025: "PT_WSTUSR_25SEP2025",
    PT_USR_4SEP2025: "PT_USR_4SEP2025",
    PT_SLVLUSD_25SEP2025: "PT_SLVLUSD_25SEP2025",
    PT_TUSDE_25SEP2025: "PT_TUSDE_25SEP2025",
    PT_PUSDE_16OCT2025: "PT_PUSDE_16OCT2025",
    PT_SUSDE_27NOV2025: "PT_SUSDE_27NOV2025",
    PT_USDE_27NOV2025: "PT_USDE_27NOV2025",
    PT_TUSDE_18DEC2025: "PT_TUSDE_18DEC2025",
    PT_SYRUPUSDC_30OCT2025: "PT_SYRUPUSDC_30OCT2025",
    PT_WSRUSD_30OCT2025: "PT_WSRUSD_30OCT2025",
} as const;
export type PendlePtLockTokenId = keyof typeof PENDLE_PT_LOCK_TOKEN_IDS;

/** tokens that can be locked */
export const LOCK_TOKEN_IDS = {
    [COMMON_TOKEN_IDS.USDC]: COMMON_TOKEN_IDS.USDC,
    [COMMON_TOKEN_IDS.IUSD]: COMMON_TOKEN_IDS.IUSD,
    [COMMON_TOKEN_IDS.SIUSD]: COMMON_TOKEN_IDS.SIUSD,
    // Pendle tokens with expiry dates
    ...PENDLE_PT_LOCK_TOKEN_IDS,
} as const;
export type LockTokenId = keyof typeof LOCK_TOKEN_IDS;

export const TOKEN_IDS = {
    ...COMMON_TOKEN_IDS,
    ...LOCK_TOKEN_IDS,
} as const;
export type TokenId = keyof typeof TOKEN_IDS;

export type TokenBalances = Record<TokenId, string>;

export interface Token {
    id: TokenId;
    name: string;
    symbol: string;
    address: Address;
    decimals: number;
}
